import React from 'react';
import { ProjectCard, ProjectCardProps } from './ProjectCard';

export type ProjectCardControllerProps = ProjectCardProps;

export const ProjectCardController = (props: ProjectCardControllerProps) => {
  return <ProjectCard {...props} />;
};
